import { useState } from "react";

import { GlobalConfigurationEditForm } from "src/app/features/GlobalConfiguration/components/forms/GlobalConfigurationEditForm";
import { useGlobalConfigurationLoadQuery } from "src/app/features/GlobalConfiguration/services/server/GlobalConfigurationApi";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { HistoryButton } from "../../../../components/FeatureButtons/HistoryButton";
import { RefreshButton } from "../../../../components/FeatureButtons/RefreshButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { FORM_ACTION } from "../../../../core/router/types/routerTypes";

export const GlobalConfigurationEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const { data: entity } = useGlobalConfigurationLoadQuery();
    const historyUrl = entity?.id ? `global-configuration/${entity.id}/${FORM_ACTION.HISTORY}` : undefined;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.globalConfigurationEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                    <HistoryButton url={historyUrl} />
                    <RefreshButton isDisabled={false} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <GlobalConfigurationEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
